import Oraculo from './components/Oraculo'; // import Oraculo, { getQueryFromDataLayer } from './components/Oraculo'

import OraculoMobile from './components/OraculoMobile';
import Trie from './utils/trie';
import { debounceCall } from './utils/extras';
import { hasCategory, getCategorySuggestions } from './utils/categorySuggestions';
import { SearchHistoryModule } from './utils/searchHistory';
import { getFriendlyUrl } from './utils/suggestionUrlFormatter';
import { sendTracking, formatSubmitTrackingPayload, formatCategorySuggestionTrackingPayload, formatHistorySuggestionTrackingPayload } from './utils/events'; // export * from './utils/searchHistory'

export { OraculoMobile, Trie, debounceCall, hasCategory, getCategorySuggestions, SearchHistoryModule, getFriendlyUrl, sendTracking, formatSubmitTrackingPayload, formatCategorySuggestionTrackingPayload, formatHistorySuggestionTrackingPayload };
export default Oraculo;